@use "foundation/colors";
@use "foundation/responsive";

.payment-info-form {
  margin: 0 auto;

  @include responsive.phone {
    width: 100%;
  }

  .action-buttons {
    text-align: center;
  }

  .mobile-top {
    @include responsive.phone {
      margin-top: 24px;
    }
  }
}
